import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import usePermissions from '../../../../hooks/usePermissions'

import { insertIf } from '../../../../helpers/common'
import { getAdEditFormName } from '../helpers'

import { updateAdStatus, updateAd } from '../../../../modules/actions/ads'
import { openForm } from '../../../../modules/actions/forms'

import { listItemChangeStatus } from '../../../../constants/other'
import { GOOGLE_PLATFORM } from '../../../../constants/selectLists/platformList'
import { CHANGE_ADS_HISTORY } from '../../../../constants/forms'

const useGetAdDropdownOptions = (selectedPlatform, selectedAdAccountId) => {
  const dispatch = useDispatch()
  const permissions = usePermissions()

  const hasPermissions = permissions.can('update', 'Ad')

  const editAdHandler = useCallback(
    (id, isInternalAd) => {
      dispatch(
        openForm({
          id,
          formName: getAdEditFormName(selectedPlatform),
          ...(isInternalAd && { otherParams: 'internal=true' })
        })
      )
    },
    [dispatch, selectedPlatform]
  )

  const changeAdStatusHandler = useCallback(
    (id, status) => {
      if (selectedPlatform === GOOGLE_PLATFORM) {
        // google has separate endpoint to change ad status
        dispatch(
          updateAdStatus({
            status: listItemChangeStatus[status].changeTo,
            adAccountId: selectedAdAccountId,
            platform: GOOGLE_PLATFORM,
            id
          })
        )
      } else {
        dispatch(
          updateAd(
            {
              status: listItemChangeStatus[status].changeTo,
              account: selectedAdAccountId
            },
            id,
            selectedPlatform
          )
        )
      }
    },
    [dispatch, selectedPlatform, selectedAdAccountId]
  )

  return useCallback(
    ({ id, status, internal, ad } = {}) => {
      const isInternalAd = !!internal
      // todo remove once google image ad type will be implemented
      const isGoogleImageAdType = selectedPlatform === GOOGLE_PLATFORM && ad?.type === 'IMAGE_AD'

      return hasPermissions
        ? [
            ...insertIf(!isGoogleImageAdType, {
              text: 'Edit',
              onClickHandler: () => editAdHandler(id, isInternalAd)
            }),
            ...insertIf(!isInternalAd, {
              text: status === 'active' ? 'Pause' : 'Activate',
              onClickHandler: () => changeAdStatusHandler(id, status)
            }),
            {
              text: 'Change History',
              onClickHandler: () => dispatch(openForm({ id, formName: CHANGE_ADS_HISTORY }))
            }
          ]
        : []
    },
    [selectedPlatform, hasPermissions, editAdHandler, changeAdStatusHandler, dispatch]
  )
}

export default useGetAdDropdownOptions
